import React from 'react';
import { MotionConfig } from 'framer-motion';
import { TopBar } from '../components/mk/TopBar';
import { Hero } from '../components/mk/Hero';
import { StatsBar } from '../components/mk/StatsBar';
import { Difference } from '../components/mk/Difference';
import { Recognize } from '../components/mk/Recognize';
import { WhatsInside } from '../components/mk/WhatsInside';
import { InsidePages } from '../components/mk/InsidePages';
import { Bonuses } from '../components/mk/Bonuses';
import { HowItWorks } from '../components/mk/HowItWorks';
import { Audience } from '../components/mk/Audience';
import { Offer } from '../components/mk/Offer';
import { Guarantee } from '../components/mk/Guarantee';
import { Faq } from '../components/mk/Faq';
import { FinalCta } from '../components/mk/FinalCta';
import { Footer } from '../components/mk/Footer';
export function LandingPage() {
  return <MotionConfig reducedMotion="user" data-id="element-574" data-mp="llw724xx5mkl">
      <div lang="en" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-575" data-mp="lmxrh00trlez">
        <TopBar data-id="element-576" data-mp="2zjymru2xailg" />
        <main data-id="element-577" data-mp="2zki3x8kr12yf">
          <Hero data-id="element-578" data-mp="2zgu9863kiai4" />
          <StatsBar data-id="element-579" data-mp="33kigenoaf42u" />
          <Difference data-id="element-580" data-mp="33k0o224qxa07" />
          <Recognize data-id="element-581" data-mp="33lbr1zqdadq9" />
          <WhatsInside data-id="element-582" data-mp="33ks6eb9c1b8j" />
          <InsidePages data-id="element-583" data-mp="38jln0cjx1icx" />
          <Bonuses data-id="element-584" data-mp="38j3h0o7gbprt" />
          <HowItWorks data-id="element-585" data-mp="38ik81wzs4bpx" />
          <Audience data-id="element-586" data-mp="38iaksh64cinx" />
          <Offer data-id="element-587" data-mp="38hscuna3gg06" />
          <Guarantee data-id="element-588" data-mp="3da22e27are1x" />
          <Faq data-id="element-589" data-mp="3dbdf4ripzw56" />
          <FinalCta data-id="element-590" data-mp="3db3l8suk14u7" />
        </main>
        <Footer data-id="element-591" data-mp="3dc6g1buzzrfe" />
      </div>
    </MotionConfig>;
}